export default {
  // 模块名称
  realTimeAlarm: {
    // 按钮类
    button: {
      save: '保存',
      reset: '重置',
      conform: '确定',
      cancel: '取消',
      prompt: '提示',
      whole: '全选'
    },
    // 文字标签类
    label: {
      alarmLevel: '告警级别',
      area: '区域',
      description: '处理描述',
      alarmName: '告警名称',
      alarmType: '告警类型',
      realTimeVideo: '实时视频',
      historyVideo: '录像回放',
      videoUrl: '上传视频',
      reportPersonName: '上报人员',
      alarmTime: '告警时间',
      groupName: '告警位置',
      ip: '告警IP',
      desc: '告警描述',
      scan: '实时浏览',
      play: '录像回放',
      conDevice: '配置联动设备',
      deviceName: '设备名称',
      location: '位置',
      bility: '能力',
      mail: '米',
      operation: '操作',
      unlink: '取消关联',
      fmeters: '5米',
      tmeters: '5-10米',
      twlmeters: '10-20米',
      twlemeters: '20-30米',
      feemeters: '30-50米',
      onemeters: '50-100米',
      choiceGroup: '选择执行组',
      taskPersonnelList: '任务人员列表',
      assign: '立即指派',
      doPerson: '执行人员',
      user: '账户名',
      fastUp: '告警快速下发',
      allTypes: '所有类型',
      watch: '查看',
      noDatas: '暂无',
      resShow: '资源展示',
      chooseDev: '请选择设备',
      chooseArea: '请选择区域',
      mapPic: '地图图层',
      indoor: '室内',
      outdoor: '室外',
      choose: '选择',
      export: '出口',
      onefloor: '二层',
      tfloor: '三层'
    },
    // 提示类
    placeholder: {
      please: '请选择',
      input: '请输入',
      startTime: '开始时间',
      endTime: '结束时间'
    },
    // 消息类
    message: {
      confirmSuc: '提交成功',
      disableSet: '此告警没有关联相关设备, 不能设置联动规则！',
      queryFailed: '查询失败！',
      enterDesc: '请输入处理描述（10-200字）',
      length: '长度在 10 到 200 个字符',
      setRules: '此告警没有关联相关设备, 不能设置联动规则！',
      cancelWarn: '是否取消关联选择的设备？',
      cancelOk: '取消成功',
      listNull: '联动规则告警事件类型列表为空!',
      doListNull: '联动规则联动动作列表为空！',
      countLen: '联动设备数量不能超过20个！',
      configuration: '配置成功！',
      alarmType: '请选择告警类型',
      disableChoose: '您还没有选择执行组',
      issueSuc: '任务下发成功',
      noDevice: '当前告警无设备信息！',
      noPlan: '设备无录像计划！'
    },
    // 标题类
    title: {
      noData: '暂无数据',
      capPic: '抓拍图片',
      alarmDesc: '告警详情',
      alarmDeal: '告警处理',
      confirmAlarm: '确认告警',
      false: '误报',
      taskDelivery: '任务下发',
      patrol: '视频巡逻_',
      resourse: '资源详情',
      device: '已关联设备',
      alarmList: '告警列表',
      childSys: '子系统',
      alarmInfo: '告警信息',
      stop: '停止',
      FastBackward: '快退',
      Speed: '快进',
      Multiple: '倍速',
      NofullScreen: '退出全屏',
      pause: '暂停',
      NoPlay: '当前无可播放录像信息',
      planImplementation: '预案执行'
    }
  }
}
